import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Envelope = ({ data, onOpened }) => {
  const [opening, setOpening] = useState(false);
  const { names } = data;

  const handleOpen = () => {
    if (opening) return;
    setOpening(true);
  };

  return (
    <AnimatePresence>
      <motion.div
        data-testid="envelope-overlay"
        className="overlay-solid fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden px-6"
        initial={{ opacity: 1 }}
        animate={{ opacity: opening ? 0 : 1 }}
        transition={{ duration: 0.7, delay: opening ? 1.5 : 0 }}
        onAnimationComplete={() => {
          if (opening) onOpened && onOpened();
        }}
        style={{ pointerEvents: opening ? "none" : "auto" }}
      >
        <motion.p
          className="font-editorial mb-2 text-lg italic text-[#8C8578]"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {names.one} &amp; {names.two}
        </motion.p>
        <motion.p
          className="eyebrow mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          კონვერტი
        </motion.p>

        <motion.div
          animate={opening ? { y: 0 } : { y: [-6, 6, -6] }}
          transition={opening ? { duration: 0.4 } : { duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
        >
          <div
            data-testid="envelope-card"
            className="envelope-scene cursor-pointer"
            role="button"
            aria-label="კონვერტის გახსნა"
            onClick={handleOpen}
          >
            <div className="env-back" />

            <motion.div
              className="env-card"
              initial={{ y: "0%", opacity: 0, zIndex: 1 }}
              animate={
                opening
                  ? { y: "-122%", opacity: 1, zIndex: 60 }
                  : { y: "0%", opacity: 0, zIndex: 1 }
              }
              transition={{ duration: 0.8, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
            >
              <span className="eyebrow !text-[9px]">მოსაწვევი</span>
              <span className="text-xl leading-snug text-[#1C1917]">
                {names.one}{" "}
                <span className="font-script gold-text text-2xl">&amp;</span>{" "}
                {names.two}
              </span>
              <span className="font-display text-[11px] uppercase tracking-[0.2em] text-[#B0607A]">
                {data.date.display}
              </span>
            </motion.div>

            <div className="env-pocket" />

            <svg className="env-seams" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              <path
                d="M0.4 1 L50 50 L99.6 1 M0.4 99 L50 50 M99.6 99 L50 50"
                fill="none"
                stroke="#E0C2CE"
                strokeWidth="0.7"
                vectorEffect="non-scaling-stroke"
              />
              <rect x="0.6" y="0.6" width="98.8" height="98.8" rx="2.2" fill="none" stroke="#E0C2CE" strokeWidth="0.7" vectorEffect="non-scaling-stroke" />
            </svg>

            <motion.div
              className="env-flap"
              style={{ transformStyle: "preserve-3d" }}
              initial={{ rotateX: 0, zIndex: 40 }}
              animate={opening ? { rotateX: -172, zIndex: 5 } : { rotateX: 0, zIndex: 40 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
            />

            <motion.button
              data-testid="envelope-wax-seal"
              className="wax-seal"
              aria-label="ოქროს ბეჭედი"
              initial={{ opacity: 1, scale: 1 }}
              animate={opening ? { opacity: 0, scale: 0.5 } : { opacity: 1, scale: 1 }}
              transition={{ duration: 0.35 }}
            >
              <span>{names.initials}</span>
            </motion.button>
          </div>
        </motion.div>

        <motion.p
          className="mt-14 text-xs uppercase tracking-[0.28em] text-[#A1A1AA]"
          initial={{ opacity: 0 }}
          animate={{ opacity: opening ? 0 : 1 }}
          transition={{ duration: 0.6, delay: opening ? 0 : 0.8 }}
        >
          დააჭირეთ კონვერტს გასახსნელად
        </motion.p>
      </motion.div>
    </AnimatePresence>
  );
};

export default Envelope;
